/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
    ValueToJSONTyped,
} from './Value';
import type { FormulaEvaluateColumnDataType } from './FormulaEvaluateColumnDataType';
import {
    FormulaEvaluateColumnDataTypeFromJSON,
    FormulaEvaluateColumnDataTypeFromJSONTyped,
    FormulaEvaluateColumnDataTypeToJSON,
    FormulaEvaluateColumnDataTypeToJSONTyped,
} from './FormulaEvaluateColumnDataType';

/**
 * 
 * @export
 * @interface FormulaEvaluateValue
 */
export interface FormulaEvaluateValue {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    value: Value | null;
    /**
     * 
     */
    jsonType?: FormulaEvaluateColumnDataType | null;
}



/**
 * Check if a given object implements the FormulaEvaluateValue interface.
 */
export function instanceOfFormulaEvaluateValue(value: object): value is FormulaEvaluateValue {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FormulaEvaluateValueFromJSON(json: any): FormulaEvaluateValue {
    return FormulaEvaluateValueFromJSONTyped(json, false);
}

export function FormulaEvaluateValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateValue {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': ValueFromJSON(json['value']),
        'jsonType': json['jsonType'] === undefined ? undefined : json['jsonType'] === null ? null : FormulaEvaluateColumnDataTypeFromJSON(json['jsonType']),
    };
}

export function FormulaEvaluateValueToJSON(json: any): FormulaEvaluateValue {
    return FormulaEvaluateValueToJSONTyped(json, false);
}

export function FormulaEvaluateValueToJSONTyped(value?: FormulaEvaluateValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': ValueToJSON(value['value']),
        'jsonType': FormulaEvaluateColumnDataTypeToJSON(value['jsonType']),
    };
}

